
import { format } from "date-fns";
import { ptBR, es, enUS } from "date-fns/locale";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import type { Meeting } from "../../../services/meeting.service";
import type { Project } from "../../../services/project.service";
import * as customizationService from "../../../services/customization.service";

interface PreviewFooterProps {
  meeting: Meeting;
  project: Project;
}

export function PreviewFooter({ meeting, project }: PreviewFooterProps) {
  const [headerImageUrl, setHeaderImageUrl] = useState<string | null>(null);
  const { t, i18n } = useTranslation('common');
  
  const getDateLocale = () => {
    switch (i18n.language) {
      case 'es': return es;
      case 'en': return enUS;
      default: return ptBR;
    }
  };

  useEffect(() => {
    const fetchCustomization = async () => {
      try {
        const customization = await customizationService.getUserCustomization();
        setHeaderImageUrl(customization.header_image_url);
      } catch (error) {
        console.error("Erro ao carregar personalização:", error);
      }
    };

    fetchCustomization();
  }, []);
  
  const proximaReuniao = meeting.proxima_reuniao_texto?.trim();

  return (
    <footer className="mt-auto pt-8 border-t border-gray-300 text-sm text-gray-700 print:mt-6 print:pt-3">
      {proximaReuniao && (
        <div
          className="mb-4 border border-gray-300 rounded px-3 py-2"
          style={{ breakInside: "avoid", pageBreakInside: "avoid" }}
        >
          <p className="font-bold text-gray-900 text-sm">{t('next_meeting', 'Próxima reunião')}</p>
          <p className="text-gray-700 whitespace-pre-wrap">{proximaReuniao}</p>
        </div>
      )}
      <div className="flex justify-between items-start">
        <div className="flex-1">
          <p className="font-bold text-gray-900 mb-1">
            {meeting.name || `${t('meeting_minutes_number')} #${meeting.number}`}
          </p>
          <p className="font-medium text-gray-600">{project.name}</p>
          <p className="font-medium text-gray-500 text-xs mt-1">
            {t('generated_at')}{" "}
            {format(new Date(), `dd/MM/yyyy '${t('at')}' HH:mm`, { locale: getDateLocale() })}
          </p>
        </div>

        {headerImageUrl && (
          <div className="ml-4">
            <img
              src={headerImageUrl}
              alt="Logo"
              className="h-20 w-auto max-w-[300px] object-contain"
            />
          </div>
        )}
      </div>
    </footer>
  );
}

